import script from "./get_record.vue?vue&type=script&setup=true&lang=js"
export * from "./get_record.vue?vue&type=script&setup=true&lang=js"

import "../../../styles/van-sticky-nav.css?vue&type=style&index=0&id=556da83d&scoped=scoped&lang=css"
import "./get_record.vue?vue&type=style&index=1&id=556da83d&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-556da83d"]])

export default __exports__